module.exports = __webpack_public_path__ + "img/pablo.356519f8.png";